import { useAction } from 'next-safe-action/hooks'

import {
  guestSimpleReview,
  TGuestSimpleReviewRequest,
} from '@/entities/contract'
import { MessageType } from '@/shared/api'
import { useNetworkErrorHandler, useServerErrorHandler } from '@/shared/config'

type Props = {
  onSuccess: () => void
}

export const useGuestSimpleReview = ({ onSuccess }: Props) => {
  const { handleServerError } = useServerErrorHandler()
  const { handleNetworkError } = useNetworkErrorHandler()

  const action = useAction(guestSimpleReview, {
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const submitReview = async (data: TGuestSimpleReviewRequest) => {
    try {
      const res = await action.executeAsync(data)

      if (res?.data?.success) {
        onSuccess?.()
      }
    } catch (error) {
      handleNetworkError({
        error,
        title: '잠시 후 다시 시도해 주세요',
        content:
          '예기치 못한 오류가 발생했습니다.\n지속적으로 발생할 경우 고객센터로 문의해 주세요.',
        type: MessageType.ALERT,
        confirmText: '확인',
      })
    }
  }

  return { submitReview }
}
